import { MonoLabel } from '../primitives/MonoLabel.js';

interface ChanceHeroCardProps {
  /** 0-100. */
  percent: number;
  rezumatCaz: string;
  motiveCount: number;
}

function toneFor(percent: number): { label: string; color: string; bg: string; description: string } {
  if (percent >= 70) {
    return {
      label: 'Șanse mari',
      color: 'oklch(0.52 0.18 145)',
      bg: 'oklch(0.94 0.06 145)',
      description: 'peste medie',
    };
  }
  if (percent >= 40) {
    return {
      label: 'Șanse medii',
      color: '#5C4A0E',
      bg: '#FFF8E5',
      description: 'în jurul mediei',
    };
  }
  return {
    label: 'Șanse reduse',
    color: '#A12126',
    bg: '#FCE4E6',
    description: 'sub medie',
  };
}

export function ChanceHeroCard({ percent, rezumatCaz, motiveCount }: ChanceHeroCardProps) {
  const tone = toneFor(percent);
  return (
    <div
      className="relative overflow-hidden rounded-3xl p-6 sm:p-8 md:p-10 bg-fg text-bg"
      style={{
        background:
          'radial-gradient(circle at 75% 25%, oklch(0.42 0.13 145) 0%, #0A0A08 55%)',
      }}
    >
      <div
        className="absolute -top-16 -right-16 w-60 h-60 sm:-top-20 sm:-right-20 sm:w-80 sm:h-80 rounded-full opacity-50"
        style={{
          background: 'radial-gradient(circle, oklch(0.72 0.18 145 / 0.35) 0%, transparent 70%)',
        }}
      />
      <div className="relative">
        <MonoLabel color="oklch(0.72 0.18 145)">Șanse estimate de succes</MonoLabel>
        <div className="mt-4 flex items-baseline gap-2 sm:gap-3 flex-wrap">
          <span
            className="font-medium text-[72px] sm:text-[96px] lg:text-[120px] leading-[0.9] tracking-[-3px] sm:tracking-[-5px] lg:tracking-[-6px]"
            style={{ color: 'oklch(0.85 0.16 145)' }}
          >
            {percent}%
          </span>
          <span
            className="text-sm sm:text-base font-mono"
            style={{ color: tone.color === '#A12126' ? '#FF8A8E' : 'oklch(0.85 0.16 145)' }}
          >
            ↑ {tone.description}
          </span>
        </div>
        <div className="mt-2 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/8 text-xs sm:text-sm">
          <span className="w-2 h-2 rounded-full shrink-0" style={{ background: 'oklch(0.72 0.18 145)' }} />
          {tone.label} · {motiveCount} {motiveCount === 1 ? 'motiv' : 'motive'} de nulitate identificate
        </div>
        <p className="mt-5 sm:mt-6 text-base sm:text-lg leading-relaxed text-pretty max-w-2xl text-[#D8D4CB]">
          {rezumatCaz}
        </p>
      </div>
    </div>
  );
}
